import { FC } from 'react';

import { IContainerScheduleProps } from '../models/IContainerSchedule';

import styles from './styles.module.scss';

export const ContainerSchedule: FC<IContainerScheduleProps> = ({
  children,
}) => {
  return (
    <div className={styles['container-schedule']}>
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
